const aditionalUsersType = {
  DIRECT_DELIVERER: 'directDeliverer',
  TRANSHIPMENT: 'transhipment'
};
export default aditionalUsersType;
